import React from 'react';

export function CustomerStatusColumnFormatter(cellContent) {
  const {priceQuoteCustomerStatusID, priceQuoteCustomerStatusName} = cellContent;
  const commonContainerClassnames = 'badge badge-pill w-150px font-size-h4 text-nowrap';
  const getStyles = () => {
    switch (priceQuoteCustomerStatusID) {
      case 1:
        return {
          background: '#F2E6E6',
          border: '1px solid rgb(239, 65, 48)',
          color: 'rgb(239, 65, 48)',
        }
      case 2:
        return {
          background: '#F9F4E5',
          border: '1px solid rgb(253, 185, 19)',
          color: 'rgb(253, 185, 19)',
        }
      case 3:
        return {
          background: '#CDEADB',
          border: '1px solid rgb(65, 141, 88)',
          color: 'rgb(65, 141, 88)',
        }
      default:
        return {
          background: 'transparent'
        };
    }
  };

  return (
    <div
      className={commonContainerClassnames}
      style={getStyles()}
    >
      {priceQuoteCustomerStatusName}
    </div>
  )
}
